import Vue from 'vue';
import VueRouter from 'vue-router';
import EmptyMain from '@Base/pages/common/EmptyMain';
import ComprobarSolicitud from '@Base/pages/ComprobarSolicitud';
import ValidarUsuario from '@Base/pages/ValidarUsuario';
import NotificacionesMain from '@Base/pages/notificaciones/NotificacionesMain';
import SubsanacionesMain from '@Base/pages/SubsanacionesMain';
import SubidaDocumentosAlegacion from '@Base/pages/SubidaDocumentosAlegacion';
import ComprobarIban from '@Base/pages/ComprobarIban';
import DeclaracionesMain from '@Base/pages/DeclaracionesMain';
import ConfirmarSubsanacionMain from '@Base/pages/ConfirmarSubsanacionMain';
import DescargarDocumetacionMain from '@Base/pages/DescargarDocumetacionMain';
import InternalRedirect from '@Base/pages/InternalRedirect';
import store from '@Base/store';

Vue.use(VueRouter);

const routes = [
  { path: '/', name: 'login-externo', component: ComprobarSolicitud },
  {
    path: '/internal-redirect/:internalToken',
    name: 'internal-redirect',
    component: InternalRedirect,
  },
  { path: '/notificaciones', component: EmptyMain },
  { path: '/notificaciones/:id', component: EmptyMain },
  {
    path: '/notificaciones/:id/:notificacion',
    name: 'notificaciones',
    component: NotificacionesMain,
  },
  {
    path: '/documentosAlegacion/:id/:notificacion',
    name: 'documentos-alegacion',
    component: SubidaDocumentosAlegacion,
  },
  {
    path: '/comprobarIban/:id/:notificacion',
    name: 'comprobar-iban',
    component: ComprobarIban,
  },
  {
    path: '/subsanaciones/:id/:notificacion',
    name: 'subsanaciones',
    component: SubsanacionesMain,
  },
  {
    path: '/declaraciones/:id/:notificacion',
    name: 'declaraciones',
    component: DeclaracionesMain,
  },
  {
    path: '/confirmar-subsanacion/:id/:notificacion',
    name: 'confirmar-subsanacion',
    component: ConfirmarSubsanacionMain,
  },
  { path: '/descargar-documentacion', component: EmptyMain },
  {
    path: '/descargar-documentacion/:id/:notificacion',
    name: 'descargar-documentacion',
    component: DescargarDocumetacionMain,
  },
  {
    path: '/internal-redirect/:internalToken/:internalNotificacion',
    name: 'internal-redirect-notificacion',
    component: InternalRedirect,
  },
  {
    path: '/:id/:notificacion',
    name: 'accesoConNotificacion',
    component: ValidarUsuario,
  },
  { path: '/:id', name: 'acceso', component: ValidarUsuario },
  {
    path: '/complete-redirect',
    name: 'complete-redirect',
    component: ValidarUsuario,
  },
];

const router = new VueRouter({
  routes,
});

router.beforeEach((to, from, next) => {
  //comprobar token en todas las rutas.

  const { tokenGestion } = store.state.solicitud;
  const { id, notificacion } = to.params;

  const isLoginRoute = [
    'accesoConNotificacion',
    'acceso',
    'internal-redirect',
    'internal-redirect-notificacion',
  ].includes(to.name);

  if (isLoginRoute) {
    // accedemos al login
    next();
  } else if (!tokenGestion && id && notificacion) {
    //redirigimos al login al refrescar
    if (id && notificacion) {
      next({ name: 'accesoConNotificacion', params: { id, notificacion } });
    } else {
      next({ name: 'acceso', params: { id } });
    }
  } else {
    //continuamos el flujo de ejecución
    next();
  }
});

export default router;
